<div class="container-fluid py-4" *ngIf="warehouseDetails">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <div>
      <h3 class="mb-1">Warehouse Requirement Details</h3>
      <p class="text-muted mb-0">
        View complete warehouse requirement information
      </p>
    </div>

    <button class="btn btn-back" (click)="goBack()">
      <i class="fa fa-arrow-left me-2"></i>
      Back
    </button>
  </div>

  <div class="row">
    <div class="col-lg-8">
      <div class="card border-0 shadow-sm rounded-4 mb-4">
        <div class="card-body">
          <h5 class="section-title">
            <i class="fa fa-user-circle"></i>
            Contact Information
          </h5>

          <div class="info-grid">
            <div class="info-box">
              <label>Name</label>
              <span>{{ warehouseDetails.name }}</span>
            </div>

            <div class="info-box">
              <label>Mobile</label>
              <span>{{ warehouseDetails.mobile }}</span>
            </div>

            <div class="info-box">
              <label>Email</label>
              <span>{{ warehouseDetails.email }}</span>
            </div>

            <div class="info-box" *ngIf="warehouseDetails.companyName">
              <label>Company</label>
              <span>{{ warehouseDetails.companyName }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="card border-0 shadow-sm rounded-4 mb-4">
        <div class="card-body">
          <h5 class="section-title">
            <i class="fa fa-warehouse"></i>
            Warehouse Requirement
          </h5>

          <div class="row g-3">
            <div class="col-md-4">
              <div class="stat-card">
                <small>Capacity</small>
                <h4>{{ warehouseDetails.warehouseCapacityMT }} MT</h4>
              </div>
            </div>

            <div class="col-md-4">
              <div class="stat-card">
                <small>Area</small>
                <h4>{{ warehouseDetails.warehouseSizeSqMt }} m²</h4>
              </div>
            </div>

            <div class="col-md-4">
              <div class="stat-card">
                <small>Category</small>
                <h4>{{ warehouseDetails.category }}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card border-0 shadow-sm rounded-4">
        <div class="card-body">
          <h5 class="section-title">
            <i class="fa fa-align-left"></i>
            Requirement Description
          </h5>

          <p class="description">
            {{ warehouseDetails.description }}
          </p>
        </div>
      </div>
    </div>

    <div class="col-lg-4">
      <div class="card border-0 shadow-sm rounded-4 mb-4">
        <div class="card-body">
          <h5 class="section-title">
            <i class="fa fa-map-marker-alt"></i>
            Location
          </h5>

          <ul class="detail-list">
            <li>
              <strong>City</strong>
              <span>{{ warehouseDetails.nearbyCity }}</span>
            </li>
            <li>
              <strong>District</strong>
              <span>{{ warehouseDetails.district }}</span>
            </li>
            <li>
              <strong>State</strong> <span>{{ warehouseDetails.state }}</span>
            </li>
            <li>
              <strong>Zip</strong> <span>{{ warehouseDetails.zipCode }}</span>
            </li>
          </ul>
        </div>
      </div>

      <div class="card border-0 shadow-sm rounded-4">
        <div class="card-body">
          <h5 class="section-title">
            <i class="fa fa-calendar"></i>
            Schedule
          </h5>

          <ul class="detail-list">
            <li>
              <strong>Start Date</strong>
              <span>{{ warehouseDetails.tentativeStartDate }}</span>
            </li>

            <li>
              <strong>Duration</strong>
              <span>
                {{ warehouseDetails.duration?.value }}
                {{ warehouseDetails.duration?.type }}
              </span>
            </li>

            <li>
              <strong>Created</strong>
              <span>{{ warehouseDetails.createdOn }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
